import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AuthService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { CustomValidateCartService } from '../../../../services/cart/validate-cart.service';
import {
  getAllUnavailableProductsListState
} from '../../../cart/unavailable-products/store/selectors/custom-unavailable-products.selectors';
import { ICON_TYPE } from '../../../icons/icon.model';

interface modelUnavailableProducts {
  currentPage?: number;
  products?: any[];
  totalPageCount?: number;
  totalProductCount?: number;
}

@Component({
  selector: 'app-custom-unavailable-products',
  templateUrl: './custom-unavailable-products.component.html',
  styleUrls: ['./custom-unavailable-products.component.scss'],
  standalone: false
})
export class CustomUnavailableProductsComponent implements OnInit, OnDestroy {
  iconTypes = ICON_TYPE;
  unavailableProducts$: Observable<any[]>;
  isLogged: Observable<boolean>;
  protected subscriptions: Subscription = new Subscription();
  unavailableProducts: modelUnavailableProducts;

  constructor(
    private auth: AuthService,
    private store: Store,
    protected customValidateCartService: CustomValidateCartService
  ) {
    // this.customValidateCartService.unavailableProducts();
    this.unavailableProducts$ = this.store.pipe(select(getAllUnavailableProductsListState));
  }

  ngOnInit(): void {
    this.isLogged = this.auth.isUserLoggedIn();
    this.subscriptions.add(this.unavailableProducts$.subscribe(
      (data: any) => {
        this.unavailableProducts = data;
        if (data?.products?.length > 0) {
          this.subscriptions.unsubscribe();
        }
      }
    ));
  }

  ngOnDestroy() {
    // DRF, check if in s1 works properly without destroy function
    // this.customValidateCartService.resetUnavailableProducts();
    this.subscriptions.unsubscribe();
  }
}
